module.exports = __webpack_public_path__ + "img/resett.f347b132.png";